import React from "react";
import getClient from "src/graphql/client/apollo-client";
import { ApolloProvider as ApolloClientProvider } from "@apollo/client";

export function ApolloProvider({
  addError,
  children,
}: {
  addError: (error: string) => void;
  children: React.ReactNode;
}) {
  const apolloClient = React.useMemo(
    () => getClient({ errorLink: { onError: addError } }),
    [addError],
  );

  return (
    <ApolloClientProvider client={apolloClient}>
      {children}
    </ApolloClientProvider>
  );
}

export default ApolloProvider;
